import type { CSSProperties } from "react";

import { styles } from "@repo/helpers";
import { useMemo } from "react";

import type { MarkupProps } from "./types";

import { InputComponent } from "../input";
import style from "./style.module.scss";

export default function ToggleSliderMarkup(props: MarkupProps) {
	const {
		activeColor,
		inactiveColor,
		sliderBorderColor,
		hideLabel,
		rounded,
		small,
		size,
		trueLabel,
		falseLabel,
		onChange,
		...inputProps
	} = props;
	const { id, name, value, disabled } = inputProps;
	const labelPosition = hideLabel ? "hidden" : props.labelPosition;

	const inputPropsValue = useMemo(() => formatValueIfNeeded(value), [value]);
	const propsValue = useMemo(() => formatValueIfNeeded(props.value), [props.value]);

	const inlineStyle = {} as CSSProperties;
	if (activeColor && inputPropsValue) {
		inlineStyle.backgroundColor = activeColor;
	} else if (inactiveColor && !propsValue) {
		inlineStyle.backgroundColor = inactiveColor;
	}
	if (sliderBorderColor) {
		inlineStyle.borderColor = sliderBorderColor;
	}

	const sliderStyle = styles(
		props.className,
		style.slider,
		(small || size === "sm") && style.smallLine,
		size === "sm" && style.mini,
		rounded && style.sliderRound,
		disabled && style.disabled,
	);

	const switchStyle = styles(
		style.switchLabel,
		(small || size === "sm") && style.smallLabel,
		labelPosition === "left" ? style.labelLeft : style.labelRight,
	);

	const switchGroup = (
		<label className={style.switchGroup}>
			<input
				type="checkbox"
				className={style.sliderInput}
				checked={!!inputPropsValue || false}
				disabled={disabled}
				onChange={onChange}
				id={id || name}
				name={name || id}
			/>
			<span className={sliderStyle} style={inlineStyle} />
		</label>
	);
	const switchLabel = <label className={switchStyle}>{inputPropsValue ? trueLabel : falseLabel}</label>;

	return (
		<InputComponent {...inputProps}>
			<div className={style.toggleGroup}>
				{labelPosition === "left" && switchLabel}
				{switchGroup}
				{labelPosition === "right" && switchLabel}
			</div>
		</InputComponent>
	);
}

function formatValueIfNeeded(v: string | number | boolean) {
	if (typeof v != "string") return v;
	const normalized = v.trim().toLowerCase();
	if (normalized === "true") return true;
	if (normalized === "false" || normalized === "") return false;
	return v;
}
